import { Link, navigate } from "gatsby"
import PropTypes from "prop-types"
import React, { useContext } from "react"
import { FirebaseContext } from './Firebase'
import styled from 'styled-components'
import { useOnClickOutside } from '../utils/clickOutsideHook'
import Burger from "./Burger"
import BurgerMenu from '../components/styles/BurgerMenu';
import logo from '../images/ae.png'

const LogoutLink = styled.span`
  cursor: pointer;
  color: var(--gray-dark);
  &:hover{
    text-decoration: underline;
  }
`

const HeaderWrapper = styled.header`
  position: fixed;
  padding: 15px 0;
  width: 100vw;
  max-width:100%;
  z-index: 100;
  margin-bottom: 1rem;

  ${({ scroll }) => scroll &&
    `background: white;
    backdrop-filter: blur(10px);`
  }
  /*desktop version*/ 
  @media (min-width: 750px){
    width: 100vw;
    max-width:100%;
  } 
`
const HeaderContent = styled.div`
  margin: 0;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  font-size: .7rem;
  justify-content:space-between;
  max-width:100%;
  ${({ scroll }) => scroll &&
    `color:white;`
  } 
  img{
    width: 58px;
    /* margin-top: -15px; */
  }
  svg{
    width: 300px;
  }
  .NavLink{
    /*mobile version*/
  @media (max-width: 1000px) {
    display: none;
  }
  }
  .userInfo{
    display:grid;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 0;
    text-align: center;
    color: var(--text-color);
  }
`

const UserAuthLink = styled.div`
  margin:0;
  text-align:right;
  a{
    color: var(--text-color);
    text-decoration:none;
  }

 @media (max-width: 750px) {
    display:grid;
    grid-template-columns: repeat(1, 1fr);
  } 
`

const Divider = styled.span`
  margin: 0 8px;
  padding-right: 1px;
  background: #ddd;
`

const Header = ({ setUserAuth }) => {

  const [open, setOpen] = React.useState(false)

  const { firebase, userAuth } = useContext(FirebaseContext);

  const handleLogoutClick = () => {
    setUserAuth();
    localStorage.removeItem('authUser');
    firebase.logout().then(() => navigate('/login'));
    setOpen(false);
  }
  const [scroll, setScroll] = React.useState({ hasScrolled: false })

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll)
  }, [])

  const handleScroll = (event) => {
    const scrollTop = window.pageYOffset
    if (scrollTop > 50) {
      setScroll({ hasScrolled: true })
    } else {
      setScroll({ hasScrolled: false })
    }
  }
  const node = React.useRef()
  useOnClickOutside(node, () => setOpen(false))
  return (
    <HeaderWrapper scroll={scroll.hasScrolled} >
      <Burger open={open} setOpen={setOpen} />
      <BurgerMenu open={open}>
        {(!!userAuth && !!userAuth.email) &&
          <ul>
            <li>
              Salut, {userAuth.username || userAuth.displayName || userAuth.email}
            </li>
            <li>
              <Link to="/domenii" onClick={() => setOpen(false)}>Domenii</Link>
            </li>
            <li>
              <Link to="/teme" onClick={() => setOpen(false)}>Teme</Link>
            </li>
            <li>
              <Link to="/calendar" onClick={() => setOpen(false)}>Calendar</Link>
            </li>
            <li onClick={handleLogoutClick}>
              Logout
            </li>
            
          </ul>
        }
        {(!userAuth || !userAuth.email) &&
          <ul>
            <Link to="/login" onClick={() => setOpen(false)}>Login</Link>
            <Link to="/register" onClick={() => setOpen(false)}>Register</Link>
          </ul>
        }
      </BurgerMenu>
      <HeaderContent scroll={scroll.hasScrolled}>
        <Link to="/">
          <img src={logo} alt="Logo" className="logo" />
        </Link>

        <div className="NavLink">
          {(!!userAuth && !!userAuth.email) &&
            <div className="userInfo">

              <span>Salut, {userAuth.username || userAuth.displayName || userAuth.email}</span>

              <Link to="/domenii" >Domenii</Link>
              <Link to="/teme">
                <span role="img" aria-label="point">👉</span> Teme
            </Link>

              <Link to="/calendar" >Calendar</Link>
              <LogoutLink onClick={handleLogoutClick}>
                Logout
              </LogoutLink>
            </div>
          }
          {(!userAuth || !userAuth.email) &&
            <UserAuthLink>
              <Link to="/login">Login</Link>
              <Divider />
              <Link to="/register">Register</Link>
            </UserAuthLink>
          }
        </div>

      </HeaderContent>
    </HeaderWrapper>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header